/**
 * Il valore che l'utente vede davvero dentro il campo.
 *
 * La dettatura vocale di macOS, certi incolla e i riempimenti fatti da fuori scrivono
 * nel campo senza emettere l'evento `input`: a schermo il testo c'e, ma React non lo sa
 * e il suo stato resta vuoto. Un modulo che decide sullo stato, in quel caso, resta morto
 * e non dice perche. Al momento dell'invio si crede al campo, non allo stato.
 *
 * Lo stato resta come ripiego per i casi in cui il riferimento non e ancora agganciato.
 */
export function valoreDelCampo(
  campo: { value: string } | null | undefined,
  statoReact: string,
) {
  return (campo?.value ?? statoReact).trim();
}
